import { syncRef } from '@vueuse/core';

import { formatTrackingListName, type ListNameSource } from './internal/format';
import { useTrackingGlobalSale, useTrackingGlobalSales, useTrackingReferralListName } from './internal/state';

import type { PlatformSaleItemEntity, PlatformSaleListingItemEntity } from '~/types/sale.type';

export type UseTrackingContextReturn = {
    syncTrackingGlobalSale: (sale: Ref<PlatformSaleItemEntity | undefined>) => void;
    syncTrackingGlobalSales: (sales: Ref<PlatformSaleListingItemEntity[] | undefined>) => void;
    setTrackingReferralListName: (source: ListNameSource) => void;
    resetTrackingReferralListName: VoidFunction;
};

export const useTrackingContext = (): UseTrackingContextReturn => {
    const globalSale = useTrackingGlobalSale();
    const globalSales = useTrackingGlobalSales();
    const referralListName = useTrackingReferralListName();

    return {
        syncTrackingGlobalSale(sale): void {
            syncRef(sale, globalSale, { direction: 'ltr' });
        },

        syncTrackingGlobalSales(sales): void {
            syncRef(sales, globalSales, { direction: 'ltr' });
        },

        setTrackingReferralListName(source): void {
            referralListName.value = formatTrackingListName(source);
        },

        resetTrackingReferralListName(): void {
            referralListName.value = null;
        },
    };
};
